import { Route, Routes } from "react-router-dom";
import AllSocialMedia from "../pages/dashboardPage/socialMediaSettings/allSocialMedia/AllSocialMedia";

const SocialMediaNavigator = () => {
  return (
    <Routes>
      <Route path="/show-social-media" element={<AllSocialMedia />} />
      <Route path="*" element={<AllSocialMedia />} />
    </Routes>
  );
};

export default SocialMediaNavigator;
